<template>
    <jet-form-section>
        <template #title>{{ $t("profile.language.title") }}</template>

        <template #description>{{
            $t("profile.language.description")
        }}</template>

        <template #form>
            <div class="sm:col-span-4 col-span-6">
                <Label for="language">
                    {{ $t("profile.language.lang_input.label") }}</Label
                >

                <Select v-model="form.language">
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            <SelectItem
                                v-for="l of languages"
                                :key="l.value"
                                :value="l.value"
                            >
                                {{ l.label }}
                            </SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>

                <p class="mt-1 text-sm text-iron-500 tracking-[-0.01em]">
                    {{ $t("profile.language.lang_input.description") }}
                </p>
            </div>

            <div class="sm:col-span-4 col-span-6">
                <Label for="customerNotificationlanguage">
                    {{
                        $t("profile.language.communication_lang_input.label")
                    }}</Label
                >

                <Select v-model="form.customerCommunicationLanguage">
                    <SelectTrigger>
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectGroup>
                            <SelectItem
                                v-for="l of customerCommunicationLanguages"
                                :key="l.value"
                                :value="l.value"
                            >
                                {{ l.label }}
                            </SelectItem>
                        </SelectGroup>
                    </SelectContent>
                </Select>

                <p class="mt-1 text-sm text-iron-500 tracking-[-0.01em]">
                    {{
                        $t(
                            "profile.language.communication_lang_input.description",
                        )
                    }}
                </p>
            </div>
        </template>

        <template #actions>
            <Button
                size="sm"
                :loading="form.processing"
                :recently-saved="form.recentlySuccessful"
                @click.prevent="updateLanguage"
                >{{ $t("save_changes") }}</Button
            >
        </template>
    </jet-form-section>
</template>

<script setup lang="ts">
import JetFormSection from "../../Jetstream/FormSection.vue";
import { Button } from "@/components/ui/button";
import route from "ziggy-js";
import { useForm } from "@inertiajs/vue3";
import { Label } from "@/components/ui/label";
import { User } from "../Zaptime/App/Teams/types/Team";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

interface Props {
    user: User;
}

const props = defineProps<Props>();

const languages = [
    {
        label: "English",
        value: "en-US",
    },
    {
        label: "Čeština",
        value: "cs-CZ",
    },
];

const customerCommunicationLanguages = [
    {
        label: "English",
        value: "en-US",
    },
    {
        label: "Čeština",
        value: "cs-CZ",
    },
    {
        label: "Polski",
        value: "pl-PL",
    },
];

const form = useForm({
    language: props.user.language || "en-US",
    customerCommunicationLanguage:
        props.user.customer_communication_language || "en-US",
});

function updateLanguage() {
    form.put(route("user.update-language"), {
        onSuccess: () => {
            window.location.reload();
        },
    });
}

// const updateLanguage = function () {
//     loading.value = true;
//
//     router.put(
//         route("user.update-language"),
//         {
//             language: language.value,
//             customerCommunicationLanguage: customerCommunicationLanguage.value,
//         },
//         {
//             preserveScroll: true,
//             onFinish: () => {
//                 loading.value = false;
//                 window.location.reload();
//             },
//         },
//     );
// };
</script>
